import { FormationDetailProps } from '@/types/formation';

export const sstFormation: FormationDetailProps = {
  id: "2",
  title: "Formation Sauveteur Secouriste du Travail (SST)",
  description: "Apprenez les gestes de premiers secours en milieu professionnel et obtenez votre certification SST reconnue au niveau national.",
  duration: "14 heures (2 jours)",
  category: "Secourisme",
  imageSrc: "/images/formations/sst1.webp",
  slug: "sauveteur-secouriste-travail",
  reference: "F-SST",
  price: "Sur devis – nous contacter",
  targetAudience: "Tout salarié souhaitant devenir SST au sein de son entreprise",
  prerequisites: "Aucun prérequis nécessaire pour suivre la formation initiale SST",
  objectives: [
    "Intervenir efficacement face à une situation d\'accident du travail",
    "Mettre en application ses compétences au service de la prévention des risques professionnels dans son entreprise",
    "Adopter un comportement adapté en cas d\'accident, incident ou dysfonctionnement sur son lieu de travail",
    "Contribuer à la mise en œuvre d\'actions de prévention et de protection"
  ],
  program: [
    {
      title: "Domaine de compétence 1 : Intervenir face à une situation d\'accident du travail",
      items: [
        "Situer son rôle de SST dans l\'organisation des secours dans l\'entreprise",
        "Protéger de façon adaptée",
        "Examiner la victime",
        "Garantir une alerte favorisant l\'arrivée de secours adaptés au plus près de la victime",
        "Secourir la victime de manière appropriée",
        "La victime saigne abondamment",
        "La victime s\'étouffe",
        "La victime se plaint d\'un malaise",
        "La victime se plaint de brûlures",
        "La victime se plaint d\'une douleur empêchant certains mouvements",
        "La victime se plaint d\'une plaie qui ne saigne pas abondamment",
        "La victime ne répond pas mais elle respire",
        "La victime ne répond pas et ne respire pas"
      ]
    },
    {
      title: "Domaine de compétence 2 : Contribuer à la prévention des risques professionnels dans l'entreprise",
      items: [
        "Situer son rôle de SST dans l'organisation de la prévention de l'entreprise",
        'Caractériser des risques professionnels dans une situation de travail',
        'Participer à la maîtrise des risques professionnels par des actions de prévention'
      ]
    },
    {
      title: 'Évaluation et certification',
      items: [
        "Évaluation continue tout au long de la formation et évaluation certificative finale",
        "Remise du certificat de Sauveteur Secouriste du Travail pour les candidats ayant satisfait aux épreuves certificatives"
      ]
    }
  ],
  pedagogicalMethods: [
    "Exposés interactifs",
    "Démonstrations par le formateur",
    "Études de cas",
    "Mises en situation professionnelle sur des cas concrets",
    "Utilisation de mannequins et défibrillateurs de formation",
    "Formation pratique et apprentissage des gestes"
  ],
  evaluationMethods: [
    "Évaluation continue durant la formation à travers les mises en situation",
    "Évaluation certificative finale selon la grille de certification de l\'INRS",
    "QCM pour évaluation des connaissances théoriques"
  ],
  certification: "Délivrance du certificat de Sauveteur Secouriste du Travail (valable 24 mois) pour les candidats qui ont participé à l\'ensemble de la formation et satisfait aux épreuves certificatives.",
  registrationProcess: [
    "Inscription possible jusqu\'à 10 jours avant le début de la formation (sous réserve de places disponibles)",
    "Validation de l\'inscription après réception du bon de commande ou de la convention signée"
  ],
  accessibilityCriteria: "Formation accessible aux personnes en situation de handicap. Nous contacter pour adapter la formation selon les besoins spécifiques.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
